<template>
  <div class="tipDiv">
    <img src="@/assest/images/index/tip.png" class="tipImg"/>
    <i class="el-icon-close close" @click="close"></i>
    <div class="content">您有&nbsp;<span class="blue">{{num}}</span>&nbsp;份待填写的调查问卷</div>
    <el-button class="btn" @click="toWrite">立即填写</el-button>
  </div>
</template>

<script>
import { questionUserList } from "@/api/index";
export default {
  name:"tipLogged",
  props:{
    num:{
      type:[String,Number],
      default:1
    },
    curQestion:{
      type:Object,
      default:()=>{return {}}
    }
  },
  data(){
    return {
    }
  },
  methods:{
    close(){
      this.$emit('close')
    },
    toWrite(){
      //1学生 2教师 3单位 4游客
      let type = this.curQestion.userType
      let obj = {tipLoggedId:this.curQestion.id}
      if(this.num > 1){
        localStorage.removeItem('tipLoggedQestion')
      }
      if(type == 1){
        this.$router.replace({
          path: '/student/my/examinePaper',
          query: obj
        })
      }else if(type == 2){
        this.$router.replace({
          path: '/studentManage/studentManageQuestionnaire',
          query: obj
        })
      }else if(type == 3){
        this.$router.replace({
          path: '/company/companyQuestionnaire',
          query: obj
        })
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.tipDiv{
  text-align: center;
  // padding-bottom: 20px;
  position: relative;
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  padding: 30px 40px 20px;
}
.tipImg{
  width: 166px;
  height: 126px;
  z-index: 999;
  position: absolute;
  top: -90px;
  left:calc(50% - 83px);
}
.content{
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  padding-top: 30px;
  margin-bottom: 20px;
}
.btn{
  width: 114px;
  height: 32px;
  line-height: 32px;
  background: linear-gradient(270deg, rgba(0,102,255,0.9) 0%, #1AA9F6 100%);
  border-radius: 4px 4px 4px 4px;
  color: #fff;
  border: none;
  padding: 0;
  cursor: pointer;
  &:hover{
    opacity: .8;
    color: #fff;
  }
}
.close{
  position: absolute;
  right: 20px;
  top: 20px;
  color: #999;
}
.blue{
  color:#1AA9F6;
}
</style>
